import { toProductListCategoryOrUniversePage } from '@/feature/universe/services/universe.routing'

/**
 * Formats a raw breadcrumb list for catalog pages (product page, category list, universe, etc.)
 * by ensuring correct URL mapping for all but the first item.
 *
 * @param breadcrumbs - The raw breadcrumb array from GraphQL
 */
export function formatCatalogBreadcrumbs(
  breadcrumbs: { name: string; urlKey?: string | null }[] | null | undefined,
): { name: string; urlKey?: string | null }[] {
  if (!breadcrumbs) return []

  return breadcrumbs
    .filter((crumb) => Boolean(crumb.name))
    .map((crumb, index) => {
      if (index === 0) return crumb

      return {
        ...crumb,
        urlKey: toProductListCategoryOrUniversePage(crumb.urlKey ?? ''),
      }
    })
}
